import React from 'react';
import {IntlProvider, FormattedMessage, useIntl} from 'react-intl';

import {
  Divider,
  Input,
  FormGroup,
  FormField,
  Button
} from 'semantic-ui-react'

const CardCalculateWithholdingTaxUX = (props: any) => {
    return(
      <div
        style={{padding: "14px 10px 10px"}}>
        <div
          id="CardCalculateWithholdingTaxUX-div-1"
          style={{color: "rgba(26, 115, 232, 1)", fontWeight: "bold"}}>
          Calculate withholding tax (WHT)
        </div>
        <Divider
          id="CardCalculateWithholdingTaxUX-Divider-2">
        </Divider>
        <div
          id="CardCalculateWithholdingTaxUX-div-3"
          style={{display: "grid", gridTemplateColumns: "1fr 1fr", columnGap: "1rem"}}>

          <div
            id="CardCalculateWithholdingTaxUX-div-4"
            style={{borderRight: "1px solid rgba(0, 0, 0, 0.2)", paddingRight: "1rem"}}>

            <div
              id="CardCalculateWithholdingTaxUX-div-6"
              style={{fontWeight: "bold", margin: "0rem 0px 1.5rem"}}>
              {`Information: ${props.employeeFullName || "-"}`}
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-7"
              style={{display: "flex", justifyContent: "space-between", fontWeight: "bold"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-19">
                Calculation details
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-20">
                Baht
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-8"
              style={{fontWeight: "bold", marginTop: "0.75rem"}}>
              Income/Year
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-9"
              style={{margin: "0.5rem 0 0", display: "flex", alignItems: "center", justifyContent: "space-between"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-23"
                style={{margin: "0.5rem 0", fontWeight: "bold", display: "flex", alignItems: "center"}}>

                <div
                  id="CardCalculateWithholdingTaxUX-div-25"
                  style={{backgroundColor: "black", width: "4px", height: "4px", margin: "0 0.45rem 0 1rem", borderRadius: "500rem"}}>

                </div>
                <div
                  id="CardCalculateWithholdingTaxUX-div-26">
                  Salary
                </div>
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-24">

                <Input
                  className="input-price--no-border"
                  id="CardCalculateWithholdingTaxUX-Input-39"
                  readOnly={true}
                  size="mini"
                  value={props.calculationDetails?.salary ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-10"
              style={{marginTop: "0.35rem", display: "flex", alignItems: "center", justifyContent: "space-between"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-32"
                style={{margin: "0.5rem 0", fontWeight: "bold", display: "flex", alignItems: "center"}}>

                <div
                  id="CardCalculateWithholdingTaxUX-div-36"
                  style={{backgroundColor: "black", width: "4px", height: "4px", margin: "0 0.45rem 0 1rem", borderRadius: "500rem"}}>

                </div>
                <div
                  id="CardCalculateWithholdingTaxUX-div-37">
                  Position Pay
                </div>
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-33">

                <Input
                  className="input-price--no-border"
                  id="CardCalculateWithholdingTaxUX-Input-40"
                  readOnly={true}
                  size="mini"
                  value={props.calculationDetails?.positionPay ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-11"
              style={{marginTop: "0.35rem", display: "flex", alignItems: "center", justifyContent: "space-between"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-41"
                style={{margin: "0.5rem 0", fontWeight: "bold", display: "flex", alignItems: "center"}}>

                <div
                  id="CardCalculateWithholdingTaxUX-div-43"
                  style={{backgroundColor: "black", width: "4px", height: "4px", margin: "0 0.45rem 0 1rem", borderRadius: "500rem"}}>

                </div>
                <div
                  id="CardCalculateWithholdingTaxUX-div-44">
                  License Allowance
                </div>
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-42">

                <Input
                  className="input-price--no-border"
                  id="CardCalculateWithholdingTaxUX-Input-48"
                  readOnly={true}
                  size="mini"
                  value={props.calculationDetails?.licenseAllowance ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-12"
              style={{marginTop: "0.35rem", display: "flex", alignItems: "center", justifyContent: "space-between"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-49"
                style={{margin: "0.5rem 0", fontWeight: "bold", display: "flex", alignItems: "center"}}>

                <div
                  id="CardCalculateWithholdingTaxUX-div-51"
                  style={{backgroundColor: "black", width: "4px", height: "4px", margin: "0 0.45rem 0 1rem", borderRadius: "500rem"}}>

                </div>
                <div
                  id="CardCalculateWithholdingTaxUX-div-52">
                  Language Pay
                </div>
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-50">

                <Input
                  className="input-price--no-border"
                  id="CardCalculateWithholdingTaxUX-Input-56"
                  readOnly={true}
                  size="mini"
                  value={props.calculationDetails?.languagePay ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-57"
              style={{marginTop: "0.35rem", display: "flex", alignItems: "center", justifyContent: "space-between"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-58"
                style={{margin: "0.5rem 0", fontWeight: "bold", display: "flex", alignItems: "center"}}>

                <div
                  id="CardCalculateWithholdingTaxUX-div-60"
                  style={{backgroundColor: "black", width: "4px", height: "4px", margin: "0 0.45rem 0 1rem", borderRadius: "500rem"}}>

                </div>
                <div
                  id="CardCalculateWithholdingTaxUX-div-61">
                  Level skill
                </div>
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-59">

                <Input
                  className="input-price--no-border"
                  id="CardCalculateWithholdingTaxUX-Input-66"
                  readOnly={true}
                  size="mini"
                  value={props.calculationDetails?.skillPay?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-67"
              style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0.35rem"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-77"
                style={{fontWeight: "bold"}}>
                Total income
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-78">

                <Input
                  className="input-price--no-border"
                  id="CardCalculateWithholdingTaxUX-Input-106"
                  readOnly={true}
                  size="mini"
                  value={props.calculationDetails?.totalIncome ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-68"
              style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0.35rem"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-79"
                style={{fontWeight: "bold"}}>
                Less legal expenses
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-80">

                <Input
                  className="input-price--no-border"
                  id="CardCalculateWithholdingTaxUX-Input-105"
                  readOnly={true}
                  size="mini"
                  value={props.calculationDetails?.lessLegalExpenses ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-69"
              style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0.35rem"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-81"
                style={{fontWeight: "bold"}}>
                Net income after expenses
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-82">

                <Input
                  className="input-price--no-border"
                  id="CardCalculateWithholdingTaxUX-Input-104"
                  readOnly={true}
                  size="mini"
                  value={props.calculationDetails?.netIncomeAfterExpenses ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-70"
              style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0.35rem"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-83"
                style={{fontWeight: "bold"}}>
                Less allowance
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-84">

                <Input
                  className="input-price--no-border"
                  id="CardCalculateWithholdingTaxUX-Input-103"
                  readOnly={true}
                  size="mini"
                  value={props.calculationDetails?.lessAllowance ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-71"
              style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0.35rem", marginBottom: "3rem"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-85"
                style={{fontWeight: "bold"}}>
                Net income
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-86">

                <Input
                  className="input-price--no-border"
                  id="CardCalculateWithholdingTaxUX-Input-102"
                  readOnly={true}
                  size="mini"
                  value={props.calculationDetails?.netIncome ?? ""}>
                </Input>
              </div>
            </div>
            <Divider
              id="CardCalculateWithholdingTaxUX-Divider-111">
            </Divider>
            <div
              id="CardCalculateWithholdingTaxUX-div-112"
              style={{fontWeight: "bold", marginBottom: "1rem"}}>
              Calculation annual tax
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-113"
              style={{display: "grid", gridTemplateColumns: "1fr 25% 25%", rowGap: "1.25rem", color: "rgba(57, 55, 55, 1)"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-114"
                style={{fontWeight: "bold"}}>
                Net Income (Baht)
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-115"
                style={{fontWeight: "bold", textAlign: "center"}}>
                Tax Rate
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-116"
                style={{fontWeight: "bold", textAlign: "right"}}>
                Tax Amount
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-117">
                0 - 150,000
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-118"
                style={{textAlign: "center"}}>
                0%
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-119"
                style={{textAlign: "right"}}>
                {props.calculationAnnualTax?.["0"]?? "-"}
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-120">
                150,001 - 300,000
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-121"
                style={{textAlign: "center"}}>
                5%
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-122"
                style={{textAlign: "right"}}>
                {props.calculationAnnualTax?.["150001"]?? "-"}
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-123">
                300,001 - 500,000
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-124"
                style={{textAlign: "center"}}>
                10%
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-125"
                style={{textAlign: "right"}}>
                {props.calculationAnnualTax?.["300001"]?? "-"}
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-126">
                500,001 - 750,000
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-127"
                style={{textAlign: "center"}}>
                15%
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-128"
                style={{textAlign: "right"}}>
                {props.calculationAnnualTax?.["500001"]?? "-"}
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-129">
                750,001 - 1,000,000
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-130"
                style={{textAlign: "center"}}>
                20%
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-131"
                style={{textAlign: "right"}}>
                {props.calculationAnnualTax?.["750001"]?? "-"}
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-132">
                1,000,001 - 2,000,000
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-133"
                style={{textAlign: "center"}}>
                25%
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-134"
                style={{textAlign: "right"}}>
                {props.calculationAnnualTax?.["1000001"]?? "-"}
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-135">
                2,000,001 - 5,000,000
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-136"
                style={{textAlign: "center"}}>
                30%
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-137"
                style={{textAlign: "right"}}>
                {props.calculationAnnualTax?.["2000001"]?? "-"}
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-138">
                5,000,001 up
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-139"
                style={{textAlign: "center"}}>
                35%
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-140"
                style={{textAlign: "right"}}>
                {props.calculationAnnualTax?.["5000001"]?? "-"}
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-141"
              style={{marginTop: "1.5rem", textAlign: "right", fontWeight: "bold"}}>
              {props.calculationAnnualTax?.["taxPayable"]?? "-"}
            </div>
          </div>
          <div
            id="CardCalculateWithholdingTaxUX-div-5">

            <div
              id="CardCalculateWithholdingTaxUX-div-13"
              style={{display: "flex", justifyContent: "space-between", fontWeight: "bold", marginTop: "2.5rem"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-27">
                Allowance
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-28">
                Baht
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-14"
              style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "2.175rem"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-29"
                style={{fontWeight: "bold"}}>
                Personal
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-30">

                <Input
                  className="priceInput"
                  id="CardCalculateWithholdingTaxUX-Input-31"
                  name="personal"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+.]$/.test(e.key) && e.preventDefault()}
                  size="mini"
                  type="number"
                  value={props.allowance?.personal ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-15"
              style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0.35rem"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-34"
                style={{fontWeight: "bold"}}>
                Spouse
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-35">

                <Input
                  className="priceInput"
                  id="CardCalculateWithholdingTaxUX-Input-38"
                  name="spouse"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+.]$/.test(e.key) && e.preventDefault()}
                  size="mini"
                  type="number"
                  value={props.allowance?.spouse ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-16"
              style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0.35rem"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-45"
                style={{fontWeight: "bold"}}>
                Person care
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-46">

                <Input
                  className="priceInput"
                  id="CardCalculateWithholdingTaxUX-Input-47"
                  name="personCare"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+.]$/.test(e.key) && e.preventDefault()}
                  size="mini"
                  type="number"
                  value={props.allowance?.personCare ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-17"
              style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0.35rem"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-53"
                style={{fontWeight: "bold"}}>
                Child
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-54">

                <Input
                  className="priceInput"
                  id="CardCalculateWithholdingTaxUX-Input-55"
                  name="child"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+.]$/.test(e.key) && e.preventDefault()}
                  size="mini"
                  type="number"
                  value={props.allowance?.child ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-18"
              style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0.35rem"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-62"
                style={{fontWeight: "bold"}}>
                Life insurance
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-63">

                <Input
                  className="priceInput"
                  id="CardCalculateWithholdingTaxUX-Input-64"
                  name="lifeInsurance"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+.]$/.test(e.key) && e.preventDefault()}
                  size="mini"
                  type="number"
                  value={props.allowance?.lifeInsurance ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-72"
              style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0.35rem"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-87"
                style={{fontWeight: "bold"}}>
                Health insurance
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-88">

                <Input
                  className="priceInput"
                  id="CardCalculateWithholdingTaxUX-Input-101"
                  name="healthInsurance"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+.]$/.test(e.key) && e.preventDefault()}
                  size="mini"
                  type="number"
                  value={props.allowance?.healthInsurance ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-73"
              style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0.35rem"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-89"
                style={{fontWeight: "bold"}}>
                Fund Contribution
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-90">

                <Input
                  className="priceInput"
                  id="CardCalculateWithholdingTaxUX-Input-100"
                  name="fundContribution"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+.]$/.test(e.key) && e.preventDefault()}
                  size="mini"
                  type="number"
                  value={props.allowance?.fundContribution ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-74"
              style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0.35rem"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-91"
                style={{fontWeight: "bold", paddingRight: "3rem"}}>
                Social security contributions
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-92">

                <Input
                  className="priceInput"
                  id="CardCalculateWithholdingTaxUX-Input-99"
                  name="socialSecurityAmount"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+.]$/.test(e.key) && e.preventDefault()}
                  size="mini"
                  type="number"
                  value={props.allowance?.socialSecurityAmount ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-75"
              style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0.35rem"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-93"
                style={{fontWeight: "bold"}}>
                Donation
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-94">

                <Input
                  className="priceInput"
                  id="CardCalculateWithholdingTaxUX-Input-98"
                  name="donation"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+.]$/.test(e.key) && e.preventDefault()}
                  size="mini"
                  type="number"
                  value={props.allowance?.donation ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-76"
              style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "0.35rem"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-95"
                style={{fontWeight: "bold"}}>
                Other
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-96">

                <Input
                  className="priceInput"
                  id="CardCalculateWithholdingTaxUX-Input-97"
                  name="other"
                  onChange={props.onChangeValue}
                  onKeyDown={(e: any) => /^[e\-+.]$/.test(e.key) && e.preventDefault()}
                  size="mini"
                  type="number"
                  value={props.allowance?.other ?? ""}>
                </Input>
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-107"
              style={{display: "flex", justifyContent: "space-between", alignItems: "center", marginTop: "1rem"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-108"
                style={{fontWeight: "bold"}}>
                Total allowance
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-109"
                style={{fontWeight: "bold"}}>
                {props.formattedTotalAllowance ?? ""}
              </div>
            </div>
            <div
              id="CardCalculateWithholdingTaxUX-div-142"
              style={{lineHeight: 2.25, backgroundColor: "rgba(93, 188, 210, 0.4)", padding: "10px", marginTop: "1rem", fontWeight: "bold", borderRadius: "3px"}}>

              <div
                id="CardCalculateWithholdingTaxUX-div-143">
                Estimate WHT per month
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-144"
                style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>

                <div
                  id="CardCalculateWithholdingTaxUX-div-151">
                  Annual tax payable
                </div>
                <div
                  id="CardCalculateWithholdingTaxUX-div-152">
                  {props.calculationAnnualTax?.["taxPayable"]?? "-"}
                </div>
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-145"
                style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>

                <div
                  id="CardCalculateWithholdingTaxUX-div-149">
                  Number of months
                </div>
                <div
                  id="CardCalculateWithholdingTaxUX-div-150"
                  style={{fontWeight: "normal"}}>
                  12 months
                </div>
              </div>
              <div
                id="CardCalculateWithholdingTaxUX-div-146"
                style={{display: "flex", justifyContent: "space-between", alignItems: "center"}}>

                <div
                  id="CardCalculateWithholdingTaxUX-div-147">
                  Withholding tax per month
                </div>
                <div
                  id="CardCalculateWithholdingTaxUX-div-148"
                  style={{fontWeight: "normal"}}>
                  {props.calculationAnnualTax?.["taxPerMonth"]?? "-"}
                </div>
              </div>
            </div>
          </div>
        </div>
        <div
          className="ui form"
          id="CardCalculateWithholdingTaxUX-div-153">

          <FormGroup
            id="CardCalculateWithholdingTaxUX-FormGroup-154"
            inline={true}
            style={{marginTop: "1rem"}}>
            <FormField
              id="CardCalculateWithholdingTaxUX-FormField-155"
              style={{flex:1}}>
            </FormField>
            <FormField
              id="CardCalculateWithholdingTaxUX-FormField-156"
              inline={true}>
              <Button
                basic={true}
                color="grey"
                id="CardCalculateWithholdingTaxUX-Button-158"
                onClick={props.onClose}
                size="small"
                style={{width: "7rem"}}>
                CANCEL
              </Button>
            </FormField>
            <FormField
              id="CardCalculateWithholdingTaxUX-FormField-157"
              inline={true}>
              <Button
                color="green"
                id="CardCalculateWithholdingTaxUX-Button-160"
                onClick={props.onSave}
                size="small"
                style={{width: "7rem"}}>
                SAVE
              </Button>
            </FormField>
          </FormGroup>
        </div>
      </div>
    )
}


export default CardCalculateWithholdingTaxUX

export const screenPropsDefault = {"cannotPay":false,"cashAmountText":"14","citizenID":"31020000552","oweText":123,"patientNameAndHN":"HN: xxxxx นายทดสอบ","sumAmount":{"price":100,"reimbursable":42}}

/* Date Time : Fri Jul 18 2025 10:11:03 GMT+0700 (Indochina Time)
/* Original screen Data ************************************************************

{
  "elements": [
    {
      "id": 0,
      "name": "div",
      "parent": -1,
      "props": {
        "id": {
          "type": "value",
          "value": ""
        },
        "style": {
          "type": "code",
          "value": "{padding: \"14px 10px 10px\"}"
        }
      },
      "seq": 0
    },
    {
      "from": null,
      "id": 1,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": "Calculate withholding tax (WHT)"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-1"
        },
        "style": {
          "type": "code",
          "value": "{color: \"rgba(26, 115, 232, 1)\", fontWeight: \"bold\"}"
        }
      },
      "seq": 1,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 2,
      "name": "Divider",
      "parent": 0,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Divider-2"
        }
      },
      "seq": 2,
      "void": false
    },
    {
      "from": null,
      "id": 3,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-3"
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\", gridTemplateColumns: \"1fr 1fr\", columnGap: \"1rem\"}"
        }
      },
      "seq": 3,
      "void": false
    },
    {
      "from": null,
      "id": 4,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-4"
        },
        "style": {
          "type": "code",
          "value": "{borderRight: \"1px solid rgba(0, 0, 0, 0.2)\", paddingRight: \"1rem\"}"
        }
      },
      "seq": 4,
      "void": false
    },
    {
      "from": null,
      "id": 5,
      "name": "div",
      "parent": 3,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-5"
        }
      },
      "seq": 5,
      "void": false
    },
    {
      "from": null,
      "id": 6,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "`Information: ${props.employeeFullName || \"-\"}`"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-6"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", margin: \"0rem 0px 1.5rem\"}"
        }
      },
      "seq": 6,
      "void": false
    },
    {
      "from": null,
      "id": 7,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-7"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", fontWeight: \"bold\"}"
        }
      },
      "seq": 7,
      "void": false
    },
    {
      "from": null,
      "id": 8,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "Income/Year"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-8"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginTop: \"0.75rem\"}"
        }
      },
      "seq": 8,
      "void": false
    },
    {
      "from": null,
      "id": 9,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-9"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0.5rem 0 0\", display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 9,
      "void": false
    },
    {
      "from": null,
      "id": 10,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-10"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"0.35rem\", display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 10,
      "void": false
    },
    {
      "from": null,
      "id": 11,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-11"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"0.35rem\", display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 11,
      "void": false
    },
    {
      "from": null,
      "id": 12,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-12"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"0.35rem\", display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 12,
      "void": false
    },
    {
      "from": null,
      "id": 13,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-13"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", fontWeight: \"bold\", marginTop: \"2.5rem\"}"
        }
      },
      "seq": 13,
      "void": false
    },
    {
      "from": null,
      "id": 14,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-14"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginTop: \"2.175rem\"}"
        }
      },
      "seq": 14,
      "void": false
    },
    {
      "from": null,
      "id": 15,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-15"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginTop: \"0.35rem\"}"
        }
      },
      "seq": 15,
      "void": false
    },
    {
      "from": null,
      "id": 16,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-16"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginTop: \"0.35rem\"}"
        }
      },
      "seq": 16,
      "void": false
    },
    {
      "from": null,
      "id": 17,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-17"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginTop: \"0.35rem\"}"
        }
      },
      "seq": 17,
      "void": false
    },
    {
      "from": null,
      "id": 18,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-18"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginTop: \"0.35rem\"}"
        }
      },
      "seq": 18,
      "void": false
    },
    {
      "from": null,
      "id": 19,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "Calculation details"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-19"
        }
      },
      "seq": 19,
      "void": false
    },
    {
      "from": null,
      "id": 20,
      "name": "div",
      "parent": 7,
      "props": {
        "children": {
          "type": "value",
          "value": "Baht"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-20"
        }
      },
      "seq": 20,
      "void": false
    },
    {
      "from": null,
      "id": 23,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-23"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0.5rem 0\", fontWeight: \"bold\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 23,
      "void": false
    },
    {
      "from": null,
      "id": 24,
      "name": "div",
      "parent": 9,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-24"
        }
      },
      "seq": 24,
      "void": false
    },
    {
      "from": null,
      "id": 25,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-25"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"black\", width: \"4px\", height: \"4px\", margin: \"0 0.45rem 0 1rem\", borderRadius: \"500rem\"}"
        }
      },
      "seq": 25,
      "void": false
    },
    {
      "from": null,
      "id": 26,
      "name": "div",
      "parent": 23,
      "props": {
        "children": {
          "type": "value",
          "value": "Salary"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-26"
        }
      },
      "seq": 26,
      "void": false
    },
    {
      "from": null,
      "id": 27,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "Allowance"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-27"
        }
      },
      "seq": 27,
      "void": false
    },
    {
      "from": null,
      "id": 28,
      "name": "div",
      "parent": 13,
      "props": {
        "children": {
          "type": "value",
          "value": "Baht"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-28"
        }
      },
      "seq": 28,
      "void": false
    },
    {
      "from": null,
      "id": 29,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": "Personal"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-29"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 29,
      "void": false
    },
    {
      "from": null,
      "id": 30,
      "name": "div",
      "parent": 14,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-30"
        }
      },
      "seq": 30,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 31,
      "name": "Input",
      "parent": 30,
      "props": {
        "className": {
          "type": "value",
          "value": "priceInput"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-31"
        },
        "name": {
          "type": "value",
          "value": "personal"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+.]$/.test(e.key) && e.preventDefault()"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.allowance?.personal ?? \"\""
        }
      },
      "seq": 31,
      "void": false
    },
    {
      "from": null,
      "id": 32,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-32"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0.5rem 0\", fontWeight: \"bold\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 32,
      "void": false
    },
    {
      "from": null,
      "id": 33,
      "name": "div",
      "parent": 10,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-33"
        }
      },
      "seq": 33,
      "void": false
    },
    {
      "from": null,
      "id": 34,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": "Spouse"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-34"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 34,
      "void": false
    },
    {
      "from": null,
      "id": 35,
      "name": "div",
      "parent": 15,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-35"
        }
      },
      "seq": 35,
      "void": false
    },
    {
      "from": null,
      "id": 36,
      "name": "div",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-36"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"black\", width: \"4px\", height: \"4px\", margin: \"0 0.45rem 0 1rem\", borderRadius: \"500rem\"}"
        }
      },
      "seq": 36,
      "void": false
    },
    {
      "from": null,
      "id": 37,
      "name": "div",
      "parent": 32,
      "props": {
        "children": {
          "type": "value",
          "value": "Position Pay"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-37"
        }
      },
      "seq": 37,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 38,
      "name": "Input",
      "parent": 35,
      "props": {
        "className": {
          "type": "value",
          "value": "priceInput"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-38"
        },
        "name": {
          "type": "value",
          "value": "spouse"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+.]$/.test(e.key) && e.preventDefault()"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.allowance?.spouse ?? \"\""
        }
      },
      "seq": 38,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 39,
      "name": "Input",
      "parent": 24,
      "props": {
        "className": {
          "type": "value",
          "value": "input-price--no-border"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-39"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.calculationDetails?.salary ?? \"\""
        }
      },
      "seq": 39,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 40,
      "name": "Input",
      "parent": 33,
      "props": {
        "className": {
          "type": "value",
          "value": "input-price--no-border"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-40"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.calculationDetails?.positionPay ?? \"\""
        }
      },
      "seq": 40,
      "void": false
    },
    {
      "from": null,
      "id": 41,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-41"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0.5rem 0\", fontWeight: \"bold\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 41,
      "void": false
    },
    {
      "from": null,
      "id": 42,
      "name": "div",
      "parent": 11,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-42"
        }
      },
      "seq": 42,
      "void": false
    },
    {
      "from": null,
      "id": 43,
      "name": "div",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-43"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"black\", width: \"4px\", height: \"4px\", margin: \"0 0.45rem 0 1rem\", borderRadius: \"500rem\"}"
        }
      },
      "seq": 43,
      "void": false
    },
    {
      "from": null,
      "id": 44,
      "name": "div",
      "parent": 41,
      "props": {
        "children": {
          "type": "value",
          "value": "License Allowance"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-44"
        }
      },
      "seq": 44,
      "void": false
    },
    {
      "from": null,
      "id": 45,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": "Person care"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-45"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 45,
      "void": false
    },
    {
      "from": null,
      "id": 46,
      "name": "div",
      "parent": 16,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-46"
        }
      },
      "seq": 46,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 47,
      "name": "Input",
      "parent": 46,
      "props": {
        "className": {
          "type": "value",
          "value": "priceInput"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-47"
        },
        "min": {
          "type": "value",
          "value": ""
        },
        "name": {
          "type": "value",
          "value": "personCare"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+.]$/.test(e.key) && e.preventDefault()"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.allowance?.personCare ?? \"\""
        }
      },
      "seq": 47,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 48,
      "name": "Input",
      "parent": 42,
      "props": {
        "className": {
          "type": "value",
          "value": "input-price--no-border"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-48"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.calculationDetails?.licenseAllowance ?? \"\""
        }
      },
      "seq": 48,
      "void": false
    },
    {
      "from": null,
      "id": 49,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-49"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0.5rem 0\", fontWeight: \"bold\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 49,
      "void": false
    },
    {
      "from": null,
      "id": 50,
      "name": "div",
      "parent": 12,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-50"
        }
      },
      "seq": 50,
      "void": false
    },
    {
      "from": null,
      "id": 51,
      "name": "div",
      "parent": 49,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-51"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"black\", width: \"4px\", height: \"4px\", margin: \"0 0.45rem 0 1rem\", borderRadius: \"500rem\"}"
        }
      },
      "seq": 51,
      "void": false
    },
    {
      "from": null,
      "id": 52,
      "name": "div",
      "parent": 49,
      "props": {
        "children": {
          "type": "value",
          "value": "Language Pay"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-52"
        }
      },
      "seq": 52,
      "void": false
    },
    {
      "from": null,
      "id": 53,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": "Child"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-53"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 53,
      "void": false
    },
    {
      "from": null,
      "id": 54,
      "name": "div",
      "parent": 17,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-54"
        }
      },
      "seq": 54,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 55,
      "name": "Input",
      "parent": 54,
      "props": {
        "className": {
          "type": "value",
          "value": "priceInput"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-55"
        },
        "name": {
          "type": "value",
          "value": "child"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+.]$/.test(e.key) && e.preventDefault()"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.allowance?.child ?? \"\""
        }
      },
      "seq": 55,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 56,
      "name": "Input",
      "parent": 50,
      "props": {
        "className": {
          "type": "value",
          "value": "input-price--no-border"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-56"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.calculationDetails?.languagePay ?? \"\""
        }
      },
      "seq": 56,
      "void": false
    },
    {
      "from": null,
      "id": 57,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-57"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"0.35rem\", display: \"flex\", alignItems: \"center\", justifyContent: \"space-between\"}"
        }
      },
      "seq": 57,
      "void": false
    },
    {
      "from": null,
      "id": 58,
      "name": "div",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-58"
        },
        "style": {
          "type": "code",
          "value": "{margin: \"0.5rem 0\", fontWeight: \"bold\", display: \"flex\", alignItems: \"center\"}"
        }
      },
      "seq": 58,
      "void": false
    },
    {
      "from": null,
      "id": 59,
      "name": "div",
      "parent": 57,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-59"
        }
      },
      "seq": 59,
      "void": false
    },
    {
      "from": null,
      "id": 60,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-60"
        },
        "style": {
          "type": "code",
          "value": "{backgroundColor: \"black\", width: \"4px\", height: \"4px\", margin: \"0 0.45rem 0 1rem\", borderRadius: \"500rem\"}"
        }
      },
      "seq": 60,
      "void": false
    },
    {
      "from": null,
      "id": 61,
      "name": "div",
      "parent": 58,
      "props": {
        "children": {
          "type": "value",
          "value": "Level skill"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-61"
        }
      },
      "seq": 61,
      "void": false
    },
    {
      "from": null,
      "id": 62,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": "Life insurance"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-62"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 62,
      "void": false
    },
    {
      "from": null,
      "id": 63,
      "name": "div",
      "parent": 18,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-63"
        }
      },
      "seq": 63,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 64,
      "name": "Input",
      "parent": 63,
      "props": {
        "className": {
          "type": "value",
          "value": "priceInput"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-64"
        },
        "name": {
          "type": "value",
          "value": "lifeInsurance"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+.]$/.test(e.key) && e.preventDefault()"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.allowance?.lifeInsurance ?? \"\""
        }
      },
      "seq": 64,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 66,
      "name": "Input",
      "parent": 59,
      "props": {
        "className": {
          "type": "value",
          "value": "input-price--no-border"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-66"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.calculationDetails?.skillPay?? \"\""
        }
      },
      "seq": 66,
      "void": false
    },
    {
      "from": null,
      "id": 67,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-67"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginTop: \"0.35rem\"}"
        }
      },
      "seq": 67,
      "void": false
    },
    {
      "from": null,
      "id": 68,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-68"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginTop: \"0.35rem\"}"
        }
      },
      "seq": 68,
      "void": false
    },
    {
      "from": null,
      "id": 69,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-69"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginTop: \"0.35rem\"}"
        }
      },
      "seq": 69,
      "void": false
    },
    {
      "from": null,
      "id": 70,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-70"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginTop: \"0.35rem\"}"
        }
      },
      "seq": 70,
      "void": false
    },
    {
      "from": null,
      "id": 71,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-71"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginTop: \"0.35rem\", marginBottom: \"3rem\"}"
        }
      },
      "seq": 71,
      "void": false
    },
    {
      "from": null,
      "id": 72,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-72"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginTop: \"0.35rem\"}"
        }
      },
      "seq": 72,
      "void": false
    },
    {
      "from": null,
      "id": 73,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-73"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginTop: \"0.35rem\"}"
        }
      },
      "seq": 73,
      "void": false
    },
    {
      "from": null,
      "id": 74,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-74"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginTop: \"0.35rem\"}"
        }
      },
      "seq": 74,
      "void": false
    },
    {
      "from": null,
      "id": 75,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-75"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginTop: \"0.35rem\"}"
        }
      },
      "seq": 75,
      "void": false
    },
    {
      "from": null,
      "id": 76,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-76"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginTop: \"0.35rem\"}"
        }
      },
      "seq": 76,
      "void": false
    },
    {
      "from": null,
      "id": 77,
      "name": "div",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": "Total income"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-77"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 77,
      "void": false
    },
    {
      "from": null,
      "id": 78,
      "name": "div",
      "parent": 67,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-78"
        }
      },
      "seq": 78,
      "void": false
    },
    {
      "from": null,
      "id": 79,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": "Less legal expenses"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-79"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 79,
      "void": false
    },
    {
      "from": null,
      "id": 80,
      "name": "div",
      "parent": 68,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-80"
        }
      },
      "seq": 80,
      "void": false
    },
    {
      "from": null,
      "id": 81,
      "name": "div",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": "Net income after expenses"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-81"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 81,
      "void": false
    },
    {
      "from": null,
      "id": 82,
      "name": "div",
      "parent": 69,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-82"
        }
      },
      "seq": 82,
      "void": false
    },
    {
      "from": null,
      "id": 83,
      "name": "div",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": "Less allowance"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-83"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 83,
      "void": false
    },
    {
      "from": null,
      "id": 84,
      "name": "div",
      "parent": 70,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-84"
        }
      },
      "seq": 84,
      "void": false
    },
    {
      "from": null,
      "id": 85,
      "name": "div",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": "Net income"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-85"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 85,
      "void": false
    },
    {
      "from": null,
      "id": 86,
      "name": "div",
      "parent": 71,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-86"
        }
      },
      "seq": 86,
      "void": false
    },
    {
      "from": null,
      "id": 87,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": "Health insurance"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-87"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 87,
      "void": false
    },
    {
      "from": null,
      "id": 88,
      "name": "div",
      "parent": 72,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-88"
        }
      },
      "seq": 88,
      "void": false
    },
    {
      "from": null,
      "id": 89,
      "name": "div",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": "Fund Contribution"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-89"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 89,
      "void": false
    },
    {
      "from": null,
      "id": 90,
      "name": "div",
      "parent": 73,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-90"
        }
      },
      "seq": 90,
      "void": false
    },
    {
      "from": null,
      "id": 91,
      "name": "div",
      "parent": 74,
      "props": {
        "children": {
          "type": "value",
          "value": "Social security contributions"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-91"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", paddingRight: \"3rem\"}"
        }
      },
      "seq": 91,
      "void": false
    },
    {
      "from": null,
      "id": 92,
      "name": "div",
      "parent": 74,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-92"
        }
      },
      "seq": 92,
      "void": false
    },
    {
      "from": null,
      "id": 93,
      "name": "div",
      "parent": 75,
      "props": {
        "children": {
          "type": "value",
          "value": "Donation"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-93"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 93,
      "void": false
    },
    {
      "from": null,
      "id": 94,
      "name": "div",
      "parent": 75,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-94"
        }
      },
      "seq": 94,
      "void": false
    },
    {
      "from": null,
      "id": 95,
      "name": "div",
      "parent": 76,
      "props": {
        "children": {
          "type": "value",
          "value": "Other"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-95"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 95,
      "void": false
    },
    {
      "from": null,
      "id": 96,
      "name": "div",
      "parent": 76,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-96"
        }
      },
      "seq": 96,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 97,
      "name": "Input",
      "parent": 96,
      "props": {
        "className": {
          "type": "value",
          "value": "priceInput"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-97"
        },
        "name": {
          "type": "value",
          "value": "other"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+.]$/.test(e.key) && e.preventDefault()"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.allowance?.other ?? \"\""
        }
      },
      "seq": 97,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 98,
      "name": "Input",
      "parent": 94,
      "props": {
        "className": {
          "type": "value",
          "value": "priceInput"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-98"
        },
        "name": {
          "type": "value",
          "value": "donation"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+.]$/.test(e.key) && e.preventDefault()"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.allowance?.donation ?? \"\""
        }
      },
      "seq": 98,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 99,
      "name": "Input",
      "parent": 92,
      "props": {
        "className": {
          "type": "value",
          "value": "priceInput"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-99"
        },
        "name": {
          "type": "value",
          "value": "socialSecurityAmount"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+.]$/.test(e.key) && e.preventDefault()"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.allowance?.socialSecurityAmount ?? \"\""
        }
      },
      "seq": 99,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 100,
      "name": "Input",
      "parent": 90,
      "props": {
        "className": {
          "type": "value",
          "value": "priceInput"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-100"
        },
        "name": {
          "type": "value",
          "value": "fundContribution"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+.]$/.test(e.key) && e.preventDefault()"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.allowance?.fundContribution ?? \"\""
        }
      },
      "seq": 100,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 101,
      "name": "Input",
      "parent": 88,
      "props": {
        "className": {
          "type": "value",
          "value": "priceInput"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-101"
        },
        "name": {
          "type": "value",
          "value": "healthInsurance"
        },
        "onChange": {
          "type": "code",
          "value": "props.onChangeValue"
        },
        "onKeyDown": {
          "type": "code",
          "value": "(e: any) => /^[e\\-+.]$/.test(e.key) && e.preventDefault()"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "type": {
          "type": "value",
          "value": "number"
        },
        "value": {
          "type": "code",
          "value": "props.allowance?.healthInsurance ?? \"\""
        }
      },
      "seq": 101,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 102,
      "name": "Input",
      "parent": 86,
      "props": {
        "className": {
          "type": "value",
          "value": "input-price--no-border"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-102"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.calculationDetails?.netIncome ?? \"\""
        }
      },
      "seq": 102,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 103,
      "name": "Input",
      "parent": 84,
      "props": {
        "className": {
          "type": "value",
          "value": "input-price--no-border"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-103"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.calculationDetails?.lessAllowance ?? \"\""
        }
      },
      "seq": 103,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 104,
      "name": "Input",
      "parent": 82,
      "props": {
        "className": {
          "type": "value",
          "value": "input-price--no-border"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-104"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.calculationDetails?.netIncomeAfterExpenses ?? \"\""
        }
      },
      "seq": 104,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 105,
      "name": "Input",
      "parent": 80,
      "props": {
        "className": {
          "type": "value",
          "value": "input-price--no-border"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-105"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.calculationDetails?.lessLegalExpenses ?? \"\""
        }
      },
      "seq": 105,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 106,
      "name": "Input",
      "parent": 78,
      "props": {
        "className": {
          "type": "value",
          "value": "input-price--no-border"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Input-106"
        },
        "readOnly": {
          "type": "code",
          "value": "true"
        },
        "size": {
          "type": "value",
          "value": "mini"
        },
        "value": {
          "type": "code",
          "value": "props.calculationDetails?.totalIncome ?? \"\""
        }
      },
      "seq": 106,
      "void": false
    },
    {
      "from": null,
      "id": 107,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-107"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\", marginTop: \"1rem\"}"
        }
      },
      "seq": 107,
      "void": false
    },
    {
      "from": null,
      "id": 108,
      "name": "div",
      "parent": 107,
      "props": {
        "children": {
          "type": "value",
          "value": "Total allowance"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-108"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 108,
      "void": false
    },
    {
      "from": null,
      "id": 109,
      "name": "div",
      "parent": 107,
      "props": {
        "children": {
          "type": "code",
          "value": "props.formattedTotalAllowance ?? \"\""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-109"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 109,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 111,
      "name": "Divider",
      "parent": 4,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Divider-111"
        }
      },
      "seq": 111,
      "void": false
    },
    {
      "from": null,
      "id": 112,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": "Calculation annual tax"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-112"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", marginBottom: \"1rem\"}"
        }
      },
      "seq": 112,
      "void": false
    },
    {
      "from": null,
      "id": 113,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-113"
        },
        "style": {
          "type": "code",
          "value": "{display: \"grid\", gridTemplateColumns: \"1fr 25% 25%\", rowGap: \"1.25rem\", color: \"rgba(57, 55, 55, 1)\"}"
        }
      },
      "seq": 113,
      "void": false
    },
    {
      "from": null,
      "id": 114,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "Net Income (Baht)"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-114"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\"}"
        }
      },
      "seq": 114,
      "void": false
    },
    {
      "from": null,
      "id": 115,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "Tax Rate"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-115"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", textAlign: \"center\"}"
        }
      },
      "seq": 115,
      "void": false
    },
    {
      "from": null,
      "id": 116,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "Tax Amount"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-116"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"bold\", textAlign: \"right\"}"
        }
      },
      "seq": 116,
      "void": false
    },
    {
      "from": null,
      "id": 117,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "0 - 150,000"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-117"
        }
      },
      "seq": 117,
      "void": false
    },
    {
      "from": null,
      "id": 118,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "0%"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-118"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"center\"}"
        }
      },
      "seq": 118,
      "void": false
    },
    {
      "from": null,
      "id": 119,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "code",
          "value": "props.calculationAnnualTax?.[\"0\"]?? \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-119"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"right\"}"
        }
      },
      "seq": 119,
      "void": false
    },
    {
      "from": null,
      "id": 120,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "150,001 - 300,000"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-120"
        }
      },
      "seq": 120,
      "void": false
    },
    {
      "from": null,
      "id": 121,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "5%"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-121"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"center\"}"
        }
      },
      "seq": 121,
      "void": false
    },
    {
      "from": null,
      "id": 122,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "code",
          "value": "props.calculationAnnualTax?.[\"150001\"]?? \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-122"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"right\"}"
        }
      },
      "seq": 122,
      "void": false
    },
    {
      "from": null,
      "id": 123,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "300,001 - 500,000"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-123"
        }
      },
      "seq": 123,
      "void": false
    },
    {
      "from": null,
      "id": 124,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "10%"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-124"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"center\"}"
        }
      },
      "seq": 124,
      "void": false
    },
    {
      "from": null,
      "id": 125,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "code",
          "value": "props.calculationAnnualTax?.[\"300001\"]?? \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-125"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"right\"}"
        }
      },
      "seq": 125,
      "void": false
    },
    {
      "from": null,
      "id": 126,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "500,001 - 750,000"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-126"
        }
      },
      "seq": 126,
      "void": false
    },
    {
      "from": null,
      "id": 127,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "15%"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-127"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"center\"}"
        }
      },
      "seq": 127,
      "void": false
    },
    {
      "from": null,
      "id": 128,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "code",
          "value": "props.calculationAnnualTax?.[\"500001\"]?? \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-128"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"right\"}"
        }
      },
      "seq": 128,
      "void": false
    },
    {
      "from": null,
      "id": 129,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "750,001 - 1,000,000"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-129"
        }
      },
      "seq": 129,
      "void": false
    },
    {
      "from": null,
      "id": 130,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "20%"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-130"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"center\"}"
        }
      },
      "seq": 130,
      "void": false
    },
    {
      "from": null,
      "id": 131,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "code",
          "value": "props.calculationAnnualTax?.[\"750001\"]?? \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-131"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"right\"}"
        }
      },
      "seq": 131,
      "void": false
    },
    {
      "from": null,
      "id": 132,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "1,000,001 - 2,000,000"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-132"
        }
      },
      "seq": 132,
      "void": false
    },
    {
      "from": null,
      "id": 133,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "25%"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-133"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"center\"}"
        }
      },
      "seq": 133,
      "void": false
    },
    {
      "from": null,
      "id": 134,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "code",
          "value": "props.calculationAnnualTax?.[\"1000001\"]?? \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-134"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"right\"}"
        }
      },
      "seq": 134,
      "void": false
    },
    {
      "from": null,
      "id": 135,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "2,000,001 - 5,000,000"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-135"
        }
      },
      "seq": 135,
      "void": false
    },
    {
      "from": null,
      "id": 136,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "30%"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-136"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"center\"}"
        }
      },
      "seq": 136,
      "void": false
    },
    {
      "from": null,
      "id": 137,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "code",
          "value": "props.calculationAnnualTax?.[\"2000001\"]?? \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-137"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"right\"}"
        }
      },
      "seq": 137,
      "void": false
    },
    {
      "from": null,
      "id": 138,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "5,000,001 up"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-138"
        }
      },
      "seq": 138,
      "void": false
    },
    {
      "from": null,
      "id": 139,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "value",
          "value": "35%"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-139"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"center\"}"
        }
      },
      "seq": 139,
      "void": false
    },
    {
      "from": null,
      "id": 140,
      "name": "div",
      "parent": 113,
      "props": {
        "children": {
          "type": "code",
          "value": "props.calculationAnnualTax?.[\"5000001\"]?? \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-140"
        },
        "style": {
          "type": "code",
          "value": "{textAlign: \"right\"}"
        }
      },
      "seq": 140,
      "void": false
    },
    {
      "from": null,
      "id": 141,
      "name": "div",
      "parent": 4,
      "props": {
        "children": {
          "type": "code",
          "value": "props.calculationAnnualTax?.[\"taxPayable\"]?? \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-141"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1.5rem\", textAlign: \"right\", fontWeight: \"bold\"}"
        }
      },
      "seq": 141,
      "void": false
    },
    {
      "from": null,
      "id": 142,
      "name": "div",
      "parent": 5,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-142"
        },
        "style": {
          "type": "code",
          "value": "{lineHeight: 2.25, backgroundColor: \"rgba(93, 188, 210, 0.4)\", padding: \"10px\", marginTop: \"1rem\", fontWeight: \"bold\", borderRadius: \"3px\"}"
        }
      },
      "seq": 142,
      "void": false
    },
    {
      "from": null,
      "id": 143,
      "name": "div",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": "Estimate WHT per month"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-143"
        }
      },
      "seq": 143,
      "void": false
    },
    {
      "from": null,
      "id": 144,
      "name": "div",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-144"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\"}"
        }
      },
      "seq": 144,
      "void": false
    },
    {
      "from": null,
      "id": 145,
      "name": "div",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-145"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\"}"
        }
      },
      "seq": 145,
      "void": false
    },
    {
      "from": null,
      "id": 146,
      "name": "div",
      "parent": 142,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-146"
        },
        "style": {
          "type": "code",
          "value": "{display: \"flex\", justifyContent: \"space-between\", alignItems: \"center\"}"
        }
      },
      "seq": 146,
      "void": false
    },
    {
      "from": null,
      "id": 147,
      "name": "div",
      "parent": 146,
      "props": {
        "children": {
          "type": "value",
          "value": "Withholding tax per month"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-147"
        }
      },
      "seq": 147,
      "void": false
    },
    {
      "from": null,
      "id": 148,
      "name": "div",
      "parent": 146,
      "props": {
        "children": {
          "type": "code",
          "value": "props.calculationAnnualTax?.[\"taxPerMonth\"]?? \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-148"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 148,
      "void": false
    },
    {
      "from": null,
      "id": 149,
      "name": "div",
      "parent": 145,
      "props": {
        "children": {
          "type": "value",
          "value": "Number of months"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-149"
        }
      },
      "seq": 149,
      "void": false
    },
    {
      "from": null,
      "id": 150,
      "name": "div",
      "parent": 145,
      "props": {
        "children": {
          "type": "value",
          "value": "12 months"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-150"
        },
        "style": {
          "type": "code",
          "value": "{fontWeight: \"normal\"}"
        }
      },
      "seq": 150,
      "void": false
    },
    {
      "from": null,
      "id": 151,
      "name": "div",
      "parent": 144,
      "props": {
        "children": {
          "type": "value",
          "value": "Annual tax payable"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-151"
        }
      },
      "seq": 151,
      "void": false
    },
    {
      "from": null,
      "id": 152,
      "name": "div",
      "parent": 144,
      "props": {
        "children": {
          "type": "code",
          "value": "props.calculationAnnualTax?.[\"taxPayable\"]?? \"-\""
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-152"
        }
      },
      "seq": 152,
      "void": false
    },
    {
      "from": null,
      "id": 153,
      "name": "div",
      "parent": 0,
      "props": {
        "children": {
          "type": "value",
          "value": ""
        },
        "className": {
          "type": "value",
          "value": "ui form"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-div-153"
        }
      },
      "seq": 153,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 154,
      "name": "FormGroup",
      "parent": 153,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-FormGroup-154"
        },
        "inline": {
          "type": "code",
          "value": "true"
        },
        "style": {
          "type": "code",
          "value": "{marginTop: \"1rem\"}"
        }
      },
      "seq": 154,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 155,
      "name": "FormField",
      "parent": 154,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-FormField-155"
        },
        "style": {
          "type": "code",
          "value": "{flex:1}"
        }
      },
      "seq": 155,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 156,
      "name": "FormField",
      "parent": 154,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-FormField-156"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 156,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 157,
      "name": "FormField",
      "parent": 154,
      "props": {
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-FormField-157"
        },
        "inline": {
          "type": "code",
          "value": "true"
        }
      },
      "seq": 157,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 158,
      "name": "Button",
      "parent": 156,
      "props": {
        "basic": {
          "type": "code",
          "value": "true"
        },
        "children": {
          "type": "value",
          "value": "CANCEL"
        },
        "color": {
          "type": "value",
          "value": "grey"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Button-158"
        },
        "onClick": {
          "type": "code",
          "value": "props.onClose"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{width: \"7rem\"}"
        }
      },
      "seq": 158,
      "void": false
    },
    {
      "from": "semantic-ui-react",
      "id": 160,
      "name": "Button",
      "parent": 157,
      "props": {
        "children": {
          "type": "value",
          "value": "SAVE"
        },
        "color": {
          "type": "value",
          "value": "green"
        },
        "id": {
          "type": "value",
          "value": "CardCalculateWithholdingTaxUX-Button-160"
        },
        "onClick": {
          "type": "code",
          "value": "props.onSave"
        },
        "size": {
          "type": "value",
          "value": "small"
        },
        "style": {
          "type": "code",
          "value": "{width: \"7rem\"}"
        }
      },
      "seq": 160,
      "void": false
    }
  ],
  "forwardRef": false,
  "height": 80,
  "isMounted": false,
  "memo": false,
  "name": "CardCalculateWithholdingTaxUX",
  "project": "IsHealth",
  "screenPropsDefault": {
    "cannotPay": false,
    "cashAmountText": "14",
    "citizenID": "31020000552",
    "oweText": 123,
    "patientNameAndHN": "HN: xxxxx นายทดสอบ",
    "sumAmount": {
      "price": 100,
      "reimbursable": 42
    }
  },
  "width": 75
}

*********************************************************************************** */
